import { Box, Divider, Typography } from "@mui/material"
import React, { createContext, ReactNode, useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { AnalyticUsersClickedType, setPublicPinClicked, PublicPinClicked, GetIdFromPublicPinClicked } from "../../features/dataProcessingSlice";
import { AILoading } from "./AILoading";
import { AccountPromotion } from '../iam/AccountPromotion';
//import { showProfile } from "../../features/dialogSlice";
import { AnalyticUsers } from "./AnalyticUsers";
import { AIProfile } from "./AIProfile";
import { useAuthProfile } from "../../app/hooks";
import { Stack, IconButton, Container, Skeleton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MessageProfile } from '../MessageProfile';
import { useAIProfileSummaryQuery } from "../../features/aiAnalytics";
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetProfileQuery } from "../../features/profilesSlice";
import { useAIProfileForPinClicked } from "./AIhook";
import Button from '@mui/material/Button';
import BarChartIcon from '@mui/icons-material/BarChart';
import { SkeletonWithRetry } from "../../app/components/ProfileFetchError";
import { UniversalErrorBoundary } from "../profile/WizardErrorBoundary";

const defaulfAISummaryContextValue: AISummaryComponentProps = { bottomSheetRef: null, showAccountPromotion: false, showViewUserStoryAnalytics: true, showMessageButton: true, chatMode: false, pinToUse: false }
export const AISummaryContext = createContext(defaulfAISummaryContextValue);

export interface AISummaryComponentProps {
    children?: ReactNode;
    bottomSheetRef: any,
    showAccountPromotion: boolean,
    showViewUserStoryAnalytics?: boolean,
    showMessageButton?: boolean
    chatMode?: boolean,
    pinToUse: PublicPinClicked
    //isAuthProfileLoading: boolean
}

export const AISummary: React.FC<AISummaryComponentProps> = (props) => {
    const dispatch = useDispatch();
    return (
        <UniversalErrorBoundary
            displayVariant="inline" // <--- Selects Panel/Card mode
            onClose={() => dispatch(setPublicPinClicked(false))}
        >
            <AISummaryContent {...props} />
        </UniversalErrorBoundary>
    );
};


export const AISummaryContent: React.FC<AISummaryComponentProps> = (props) => {
    const { bottomSheetRef, showViewUserStoryAnalytics = true, showMessageButton = true, chatMode = false, children, pinToUse } = props
    //const { profile, isAuthProfileLoading } = props;
    const dispatch = useDispatch<any>()
    //const publicPinClickedAIState = useSelector((state: any) => state.dataProcessing.publicPinClicked)
    //const AIState_publicPinClicked = useTypedSelector((state: RootState) => state.dataProcessing.publicPinClicked)
    const pinId = GetIdFromPublicPinClicked(pinToUse) ?? skipToken

    const { aiSummary: AIProfileSummary, authProfile: authProfile, profile: profileToUse, isLoading, isSuccess, isError, error } = useAIProfileForPinClicked(pinId)
    const analyticUsersClickedAIState: AnalyticUsersClickedType = useSelector((state: any) => state.dataProcessing.analyticUsersClicked)

    const chatState = useSelector((state: any) => state.dialog);
    const containerRef = useRef<HTMLDivElement>(null);

    // ── View transition animation ──
    const [animDirection, setAnimDirection] = useState<'forward' | 'back'>('forward');
    const [viewKey, setViewKey] = useState(0);
    const prevAnalyticRef = useRef(analyticUsersClickedAIState);
    useEffect(() => {
        if (analyticUsersClickedAIState !== prevAnalyticRef.current) {
            setAnimDirection(analyticUsersClickedAIState !== false ? 'forward' : 'back');
            setViewKey(k => k + 1);
            prevAnalyticRef.current = analyticUsersClickedAIState;
        }
    }, [analyticUsersClickedAIState]);

    // Scroll to top when similar members list is shown
    useEffect(() => {
        if (analyticUsersClickedAIState !== false && containerRef.current) {
            // Scroll the nearest scrollable ancestor to top
            const scrollParent = containerRef.current.closest('[style*="overflow"], [class*="overflow"]') as HTMLElement
                || containerRef.current.parentElement;
            let el: HTMLElement | null = containerRef.current.parentElement;
            while (el) {
                if (el.scrollHeight > el.clientHeight && (getComputedStyle(el).overflowY === 'auto' || getComputedStyle(el).overflowY === 'scroll')) {
                    el.scrollTo({ top: 0 });
                    break;
                }
                el = el.parentElement;
            }
        }
    }, [analyticUsersClickedAIState]);

    function closeProfile() {
        dispatch(setPublicPinClicked(false))
    }

   
    
   
    //refactor(loggedInUserProfile.iam_id !== AIState.publicPinClicked && !AIState.isSuccessProfile)) {
    if (isLoading || isError)
        //console.log(AIState.publicPinProfile)
        return (
            <AISummaryContext.Provider value={props} >
                <Container>
                    <Stack sx={{ width: '100%', pt: 1, height: { xs: 'auto', sm: 'auto', md: 'calc(100vh - 80px)' } }} alignItems="center" direction="column" gap={1}>
                        <Skeleton animation="wave" variant="rectangular" width='100%' height={50} />
                        <Skeleton animation="wave" variant="rectangular" width='100%' height={250} />
                        <Skeleton animation="wave" variant="rectangular" width='100%' height={250} />
                        <Skeleton animation="wave" variant="rectangular" width='100%' height={300} />
                    </Stack>
                </Container>
            </AISummaryContext.Provider>
        )

    // if( AIState.errorGenerateAISummary ) still show this


    if (!profileToUse)
        return children ? <>{children}</> : null


    let aiSummaryRecord: any = undefined
    if (typeof analyticUsersClickedAIState !== "boolean") {
        if ((AIProfileSummary.ai_summary.length - 1) < analyticUsersClickedAIState.analyticsArrayIndex) {
            const err = `Analytic record Index out of Bound:  ${AIProfileSummary.ai_summary.length} vs ${analyticUsersClickedAIState.analyticsArrayIndex}`
            //console.log(err)
            return <>{err}</>
        }
        aiSummaryRecord = AIProfileSummary.ai_summary[analyticUsersClickedAIState.analyticsArrayIndex]
        if (aiSummaryRecord.var !== analyticUsersClickedAIState.analyticsVariable) {
            const err = `Analytic record Mismatched:  ${aiSummaryRecord.var} vs ${analyticUsersClickedAIState.analyticsVariable}`
            //console.log(err)
            return <>{err}</>
        }
        //analyticUsers = analyticUsersClickedAIState.analyticType === "numeric" ? aiSummaryRecord.analytics.users : (analyticUsersClickedAIState.analyticType === "text" ? aiSummaryRecord.analytics : undefined)

    }
    //throw new Error("TEST Profile unavaialbe.");
    if (isSuccess) {
        /*return (
            <AISummaryContext.Provider value={props} >
                <Container>
                    <Stack sx={{ width: '100%', pt: 0, height: { xs: 'auto', sm: 'auto', md: 'calc(100vh - 80px)' } }} alignItems="center" direction="column" gap={1}>
                    <AISummaryContext.Provider value={props} >
                    {analyticUsersClickedAIState !== false ?
                        <AnalyticUsers aiSummaryRecord={aiSummaryRecord} /> :
                        <>
                        <AIProfile bottomSheetRef={bottomSheetRef} profileToShow={profileToUse} AIProfileSummary={AIProfileSummary} showMessageButton={showMessageButton} showViewUserStoryAnalytics={showViewUserStoryAnalytics} chatMode={chatMode} />
                        </>
                        }
                </AISummaryContext.Provider>
                    </Stack>
                </Container>
            </AISummaryContext.Provider>
        )*/
        return (
            <Box ref={containerRef} sx={chatMode ?
                {
                    display: { xs: chatState.showChatProfile, sm: chatState.showChatProfile, md: 'flex' },
                    overflow: 'auto',
                    width: '100%',
                    height: '100%',

                }
                :
                {
                    width: '100%',
                }
            }>
                <AISummaryContext.Provider value={props} >
                    <Box
                        key={viewKey}
                        sx={viewKey > 0 ? {
                            animation: 'viewSlideIn 280ms cubic-bezier(0.4, 0, 0.2, 1)',
                            '@keyframes viewSlideIn': {
                                '0%': {
                                    opacity: 0,
                                    transform: `translateX(${animDirection === 'forward' ? '24px' : '-24px'})`,
                                },
                                '100%': {
                                    opacity: 1,
                                    transform: 'translateX(0)',
                                },
                            },
                        } : undefined}
                    >
                        {analyticUsersClickedAIState !== false ?
                            <AnalyticUsers aiSummaryRecord={aiSummaryRecord} /> :
                            <AIProfile bottomSheetRef={bottomSheetRef} profileToShow={profileToUse} AIProfileSummary={AIProfileSummary} showMessageButton={showMessageButton} showViewUserStoryAnalytics={showViewUserStoryAnalytics} chatMode={chatMode} />
                        }
                    </Box>
                </AISummaryContext.Provider>
            </Box>
        )
    }
    return null
}


